import React from 'react'
import  ButtonControls from '../ButtonControls/Buttons'
import PropTypes from 'prop-types'
import {Modal} from 'antd'
const ModalDA=({children,ButtonConfig,visible,Title,Width,OnCancel,DestroyOnClose,MaskClosable})=>{
    return (
        <Modal
        title={Title}
        wrapClassName=""
        visible={visible}
        destroyOnClose={DestroyOnClose}
        centered
        closable
        maskClosable={MaskClosable}
        width={Width}
        style={{ maxWidth: 'calc(100vw - 32px)' }}
        footer={<ButtonControls ButtonConfig={ButtonConfig} ShowCloseButton={false} />}
        onCancel={OnCancel}
        // onOk={() => this.setModal2Visible(false)}
        > 
         {children}
        </Modal>
    )
}
ModalDA.defaultProps={
    Title:"",
    visible:false,
    MaskClosable:true,
    Width:768,
    ButtonConfig:{},
    OnCancel:()=>{},
    DestroyOnClose:false
}
ModalDA.propTypes={
    Title:PropTypes.string.isRequired,
    visible:PropTypes.bool.isRequired,
    MaskClosable:PropTypes.bool.isRequired,
    Width:PropTypes.number.isRequired,
    ButtonConfig:PropTypes.object.isRequired,
    OnCancel:PropTypes.func.isRequired,
    DestroyOnClose:PropTypes.bool.isRequired

}
export default ModalDA;
